import { ReactElement } from "react";
import { IGaugeConfig } from "../../../components/charts/types";
import ProductionChart from "./productionChart";
import CardBase from "../../../components/widgets/cardBase";
import { IDetailProps } from "../../../types";

interface IComponentBProps {
  gaugeConfig: IGaugeConfig;
  value: number;
  title: string;
  detail: IDetailProps | undefined | null;
}

const ComponentB = ({ title, gaugeConfig, value, detail }: IComponentBProps): ReactElement => {
  return (
    <CardBase title={title} detail={detail}>
      <ProductionChart gaugeConfig={gaugeConfig} value={value} keyValue={title}/>
    </CardBase>
  );
};

export default ComponentB;
